import React from 'react'
import { Typography } from 'antd'
import PropTypes from 'prop-types'

import { ImageUploader } from '~components'
import { Input } from '~stories'

import styles from '../FAQPageSections/FAQAdminFields.module.css'

const { Text } = Typography

const FAQHeroFields = ({ hero, onImageUpload, onTitleChange, venueName }) => {
  const placeholder = venueName ? `${venueName} | FAQs` : 'Venue Name | FAQs'

  return (
    <div className={styles.fieldGroup}>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Hero Title</Text>
        <Input
          onChange={e => onTitleChange(e.target.value)}
          placeholder={placeholder}
          value={hero?.title || ''}
        />
        <Text className={styles.hint}>
          Headline overlaid on the hero image (e.g. Madison Square Garden | FAQs).
        </Text>
      </div>
      <div className={styles.fieldRow}>
        <Text className={styles.fieldLabel}>Hero Image</Text>
        <ImageUploader
          handleUpload={onImageUpload}
          logoUrl={hero?.image?.src || hero?.image?.url}
          pageType="faq"
        />
        <Text className={styles.hint}>Background image shown at the top of the FAQ page.</Text>
      </div>
    </div>
  )
}

FAQHeroFields.propTypes = {
  hero: PropTypes.object,
  onImageUpload: PropTypes.func.isRequired,
  onTitleChange: PropTypes.func.isRequired,
  venueName: PropTypes.string
}

export default FAQHeroFields
